export enum ModerationApiTags {
  Dashboard = 'AdminDashboardList',
  Moderation = 'Moderation',
  ModerationsList = 'ModerationsList',
}

export const moderationApiTagTypes = Array.from(Object.values(ModerationApiTags));
